/**
 * @file Turns a home summary count, `pastPromised` or `overdueInvoices`, into
 * an `AnalyticsCountFigure`. Consumer: Needs me on Home, through
 * `useHomeGoalProgress`. It follows `analyticsSummaryFigure`: an absent field,
 * which predates the field, is refused `notConfigured` with no key, a number
 * that is not a non-negative whole number fails with a message, and a refusal
 * object keeps its code and key, so no unanswered count ever reads as zero.
 */
import type { Snapshot } from 'valtio';

import type { AnalyticsSummary } from '#types';

import { analyticsSummaryUnansweredFigure } from './analyticsSummaryUnansweredFigure';
import type { AnalyticsCountFigure } from './index.types';

export const analyticsSummaryCount = (
  figure: Snapshot<AnalyticsSummary>['pastPromised' | 'overdueInvoices'],
): AnalyticsCountFigure => {
  if (typeof figure !== 'number')
    return analyticsSummaryUnansweredFigure(figure);
  return Number.isInteger(figure) && figure >= 0
    ? { status: 'answered', count: figure }
    : {
        status: 'refused',
        answer: {
          status: 'failed',
          message: `The home summary holds no count "${figure}".`,
        },
      };
};
